import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IObservation } from '../../../message-models/observation.interface';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Observation } from '../../../domain-model/observation.class';
import { consts } from '../../../common/modals/consts';
import { HelpConsts } from "../../../help/models/help-consts";

@Component({
  selector: 'app-create-or-edit-observation-modal',
  templateUrl: './create-or-edit-observation-modal.component.html',
  styleUrls: ['./create-or-edit-observation-modal.component.scss']
})

export class CreateOrEditObservationModalComponent implements OnInit, AfterViewInit {
  @Input() observation: IObservation;
  tempObservation: Observation;
  @Input() modalHeading: string = 'Observation Editor';
  @Input() isEditing: boolean;
  @Input() showSaveAndUploadButton: boolean;
  @Output() saveObservationClicked: EventEmitter<IObservation> = new EventEmitter<IObservation>();
  @Output() saveObservationDocumentRequested: EventEmitter<IObservation> = new EventEmitter<IObservation>();
  saveAttempted: boolean = false;
  showingHelp: boolean = false;
  helpText: string = HelpConsts.ObservationGuidance.sections[0].body + HelpConsts.ObservationEntryHelp.sections[0].body;
  yesButtonText: string = 'Save';
  yesButtonColour: string = 'success';


  constructor(public modalRef: DynamicDialogRef, public config: DynamicDialogConfig) {
  }

  ngOnInit(): void {
    if (this.config.data) {
      this.observation = this.config.data.observation;
      this.modalHeading = this.config.data.modalHeading;
      this.isEditing = this.config.data.isEditing;
      this.showSaveAndUploadButton = this.config.data.showSaveAndUploadButton;
      if (this.showSaveAndUploadButton) {
        this.yesButtonColour = 'warning';
        this.yesButtonText = 'Save Without Document';
      }
    }
    this.tempObservation = new Observation(this.observation as IObservation);
  }

  ngAfterViewInit() {
  }

  saveClicked() {
    const editedObservation = new Observation({
      id: this.tempObservation.id,
      summaryInfo: this.tempObservation.summaryInfo,
      notesAsHtml: this.tempObservation.notesAsHtml,
      observedBy: this.tempObservation.observedBy,
      observedOn: this.tempObservation.observedOn,
      followUpOn: this.tempObservation.followUpOn,
      observationType: this.tempObservation.observationType
    } as IObservation);
    this.saveAttempted = true;
    if (!editedObservation.isValid) {
      return;
    }
    this.saveObservationClicked.emit(editedObservation as IObservation);
    this.modalRef.close();
  }

  cancelClicked() {
    this.saveAttempted = false;
    this.isEditing = false;
    this.tempObservation = new Observation(this.observation as IObservation);
    if (this.tempObservation.id === consts.emptyGuid) {
      this.modalRef.close();
    }
  }

  editClicked() {
    this.isEditing = true;
  }

  helpClicked() {
    this.showingHelp = !this.showingHelp;
  }

  saveAndUploadDocument() {

    const editedObservation = new Observation({
      id: this.tempObservation.id,
      summaryInfo: this.tempObservation.summaryInfo,
      notesAsHtml: this.tempObservation.notesAsHtml,
      observedBy: this.tempObservation.observedBy,
      observedOn: this.tempObservation.observedOn,
      followUpOn: this.tempObservation.followUpOn,
      observationType: this.tempObservation.observationType
    } as IObservation);
    this.saveAttempted = true;
    if (!editedObservation.isValid) {
      return;
    }
    this.modalRef.close();
    this.saveObservationDocumentRequested.emit(editedObservation as IObservation);
  }
}
